import { type DietaryPreferencesTypes } from '../../machines';
import { AllergenOrDietaryProperty } from './dietary-preferences.types';

/**
 * Returns a formatted string of matched dietary restrictions
 * between user dietary restrictions and provided dietary properties.
 */
export const getProductDietaryRestrictionsNames = (
  userRestrictions: DietaryPreferencesTypes,
  dietaryProperties: readonly AllergenOrDietaryProperty[] | undefined,
) => {
  const activeRestrictions = (dietaryProperties ?? []).filter(
    (property) => userRestrictions[property.name],
  );
  const restrictionNames = activeRestrictions.map((restriction) => restriction.name.toLowerCase());

  return restrictionNames.join(', ');
};
